import moment from 'moment';
import React from 'react';
import Timestamp from '../../components/Timestamp';
import type { Scalars } from '../../graphql/generated/graphql';
import * as styles from './CommentTimestamp.module.scss';

interface CommentTimestampProps {
  insertedAt: Scalars['Datetime']['output'];
  updatedAt: Scalars['Datetime']['output'];
}

const FORMAT = 'h:mma, MMM D, YYYY';

const CommentTimestamp = ({ insertedAt, updatedAt }: CommentTimestampProps) => {
  const isEdited = updatedAt && insertedAt !== updatedAt;

  const tooltip = isEdited
    ? `Edited ${moment(updatedAt).format(FORMAT)}`
    : moment(insertedAt).format(FORMAT);

  return (
    <span className={styles.timestamp} title={tooltip}>
      <Timestamp date={insertedAt} format="short" />
      {!!isEdited && ' (edited)'}
    </span>
  );
};

export default CommentTimestamp;
